import React from "react";
import Controls from "src/components/form/controls/Controls";

const eventOption = [
  {
    id: "response",
    name: "response",
  },
  {
    id: "success",
    name: "success",
  },
  {
    id: "error",
    name: "error",
  },
];

const TTSEventPanelOptional = ({ eventType, setEventType }) => {
  return (
    <div style={{ display: "flex" }}>
      <Controls.Select
        name="eventType"
        label="Type"
        value={eventType}
        onChange={(e) => setEventType(e.target.value)}
        options={eventOption}
        style={{ width: "120px" }}
      />
    </div>
  );
};

export default TTSEventPanelOptional;
